import {useState}       from 'react';
import {Container, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, IconButton} from '@material-ui/core';
import {connect} from 'react-redux';
// Redux
import {changeView} from '../../redux/actions/Menu';
import {getFaqs, updateFaqs} from '../../redux/actions/Faqs';
// Values
import {Ic_edit, StateView, stateData} from '../../values';
// Components
import LoadingData      from '../global/LoadingData';
import Pagination       from '../global/ButtonsPagination';
// Styles
import {useStyles}  from '../../style';
// Api
import {getData}    from '../../utils/faqs';

const Tables = ({data, status, token, records, changeView, getFaqs, updateFaqs}) => {
    const classes = useStyles()
    const [page,setPage]    = useState(1)

    const edit = (item) => {
        changeView(StateView.state3)
        updateFaqs(item)
    }
    const GetData = async(page) =>{
        const res = await getData(token, `?Page=${page}`)
        getFaqs(res.data)
        window.scrollTo(0, 0)
    }
    const changePage = (e,v) =>{
        setPage(v)
        GetData(v)
    }
    const filterMaxText = (answer) =>{
        let text = answer
        if(answer.length>100){
            text = answer.substring(0, 100)
            // console.log("TEXT: ", text);
            text += '...'
        }
        return text
    }
    return (
        <div style={{position:'relative'}}>
            {
                status===stateData.state2?
                    <Container maxWidth="xl">
                        <TableContainer style={{background:'#fff'}}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow style={{background:'#132327', height:50}}>
                                        {
                                            ['Pregunta', 'Respuesta', 'Tipo', 'Editar'].map((item, index) =>
                                                <TableCell align="center" key={index} className={classes.table_title2} style={{fontFamily:'bold', color:'#fff'}}> {item} </TableCell>
                                            )
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data&&
                                        data.map((item, index) =>(
                                            <TableRow key={index} style={{borderBottom:`1px solid #f3f4f7`}}>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>{item.Question}</TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>
                                                    {filterMaxText(item.Answer)}
                                                </TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}>
                                                    {item.Type==='USER'?'Usuario':'Socio'}
                                                </TableCell>
                                                <TableCell align="center" className={classes.table_text2}>
                                                    <IconButton onClick={() => edit(item)}>
                                                        <img alt="ic_edit" src={Ic_edit} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Pagination records={records} page={page} changePage={changePage} />    
                    </Container>
                :
                    <LoadingData />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    data:       state.Faqs.faqs,
    status:     state.Faqs.status,
    token:      state.Panel.token,
    records:    state.Faqs.records
})

export default connect(mapStateToProps, {changeView, getFaqs, updateFaqs})(Tables);

